import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createLayerContainer } from '@antv/l7-core';
import { isNeedMask } from "./util";

var Tile = /*#__PURE__*/function () {
  function Tile(sourceTile, parent) {
    _classCallCheck(this, Tile);

    _defineProperty(this, "visible", true);

    _defineProperty(this, "layers", []);

    _defineProperty(this, "isLoaded", false);

    this.parent = parent;
    this.sourceTile = sourceTile;
    this.x = sourceTile.x;
    this.y = sourceTile.y;
    this.z = sourceTile.z;
    this.key = "".concat(this.x, "_").concat(this.y, "_").concat(this.z);
  }

  _createClass(Tile, [{
    key: "getLayers",
    value: function getLayers() {
      return this.layers;
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "styleUpdate",
    value: function styleUpdate() {}
  }, {
    key: "lnglatInBounds",
    value: function lnglatInBounds(lnglat) {
      var _this$sourceTile$boun = _slicedToArray(this.sourceTile.bounds, 4),
          minLng = _this$sourceTile$boun[0],
          minLat = _this$sourceTile$boun[1],
          maxLng = _this$sourceTile$boun[2],
          maxLat = _this$sourceTile$boun[3];

      var lng = lnglat.lng,
          lat = lnglat.lat;
      return lng >= minLng && lng <= maxLng && lat >= minLat && lat <= maxLat;
    }
  }, {
    key: "getLayerOptions",
    value: function getLayerOptions() {
      var options = this.parent.getLayerConfig();
      return _objectSpread(_objectSpread({}, options), {}, {
        autoFit: false,
        mask: isNeedMask(this.parent.type) || options.mask
      });
    }
  }, {
    key: "addMask",
    value: function () {
      var _addMask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(layer, mask) {
        var container;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = createLayerContainer(this.parent.sceneContainer);
                mask.setContainer(container, this.parent.sceneContainer);
                _context.next = 4;
                return mask.init();

              case 4:
                layer.addMaskLayer(mask);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addMask(_x, _x2) {
        return _addMask.apply(this, arguments);
      }

      return addMask;
    }()
  }, {
    key: "addLayer",
    value: function () {
      var _addLayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(layer) {
        var container;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // set flag
                layer.isTileLayer = true;
                container = createLayerContainer(this.parent.sceneContainer);
                layer.setContainer(container, this.parent.sceneContainer);
                this.layers.push(layer);
                _context2.next = 6;
                return layer.init();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addLayer(_x3) {
        return _addLayer.apply(this, arguments);
      }

      return addLayer;
    }()
  }, {
    key: "updateVisible",
    value: function updateVisible(value) {
      this.visible = value;
      this.updateOptions('visible', value);
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(key, value) {
      this.layers.forEach(function (l) {
        l.updateLayerConfig(_defineProperty({}, key, value));
      });
    }
    /**
     * 一个 Tile 可能有多个 layer，但是在发生拾取、点击事件的时候只有一个生效
     */

  }, {
    key: "getMainLayer",
    value: function getMainLayer() {
      return this.layers[0];
    }
  }, {
    key: "getFeatures",
    value: function getFeatures(sourceLayer) {
      return [];
    }
    /**
     * 在一个 Tile 中可能存在一个相同 ID 的 feature
     * @param id 
     * @returns 
     */

  }, {
    key: "getFeatureById",
    value: function getFeatureById(id) {
      return [];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.layers.forEach(function (layer) {
        return layer.destroy();
      });
    }
  }]);

  return Tile;
}();

export { Tile as default };